<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>批次模块</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: 'batchListProgress' }">批次进度</el-breadcrumb-item>
            <el-breadcrumb-item>批次进度图</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div id="container"
         :style="styles"></div>
  </div>
</template>
<script>
import { batchProcess } from "@/api/batch";
export default {
  data () {
    return {
      batch: {},
      styles: "",

    };
  },
  mounted () {
    this.batch = this.$route.query;
    this.getData();
  },
  methods: {
    getData () {
      console.log(batchProcess);
      batchProcess({ batchId: this.batch.id }).then((res) => {
        let x = []
        let today_amount = []
        let yesterday_amount = []
        let amount = []
        let no_amount = []
        res.forEach(element => {
          x.push(element.name)
          today_amount.push(element.today_amount)
          yesterday_amount.push(element.yesterday_amount)
          amount.push(element.amount - element.today_amount - element.yesterday_amount)
          no_amount.push(this.batch.total - element.amount)
        });
        console.log(res);
        this.show(x, today_amount, yesterday_amount, amount, no_amount)
      }).catch(() => { });
    },
    show (x, today_amount, yesterday_amount, amount, no_amount) {
      let chart = {
        type: 'column',
        height: document.documentElement.clientHeight - 155
      }

      if (x.length > 20) {
        chart.width = (x.length * 50)
        this.styles = "overflow-x: auto;min-width: 400px;height:calc(100vh - 115px)"
        chart.zoomType = 'x'

      } else if (x.length > 15 && x.length < 20) {
        this.styles = "overflow-x: auto;min-width: 400px;height:calc(100vh - 115px)"
        chart.zoomType = 'x'
      }
      Highcharts.chart('container', {
        chart: chart,
        title: {
          text: this.batch.title + "  工序进度"
        },
        xAxis: {
          categories: x
        },
        yAxis: {
          min: 0,
          title: {
            text: '件数'
          },
          stackLabels: {  // 堆叠数据标签
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          floating: true,
          backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          formatter: function () {
            return '<b>' + this.x + '</b><br/>' +
              this.series.name + ': ' + this.y + '<br/>' +
              '总量: ' + this.point.stackTotal;
          }
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white',
              style: {
                // 如果不需要数据标签阴影，可以将 textOutline 设置为 'none'
                textOutline: '1px 1px black'
              }
            }
          }
        },
        series: [{
          name: '未完成',
          color: '#E6F2FB',
          data: no_amount
        }, {
          name: '当日完成',
          color: '#13D0DC',
          data: today_amount
        }, {
          name: '昨日完成',
          color: '#0648F2',
          data: yesterday_amount
        }, {
          name: '之前完成',
          color: '#26A0F9',
          data: amount
        }]
      });
      this.$forceUpdate()
    }
  }
};
</script>
<style>
</style>
